/**
 * @generated SignedSource<<6e18cf27db54ec6fbe98350a9aea3b35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleUtilsCheckHasLiveTagArticle$data = {
  readonly flattenTypeIds: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly liveArticle: {
    readonly status: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "articleUtilsCheckHasLiveTagArticle";
};
export type articleUtilsCheckHasLiveTagArticle$key = {
  readonly " $data"?: articleUtilsCheckHasLiveTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleUtilsCheckHasLiveTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "articleUtilsCheckHasLiveTagArticle"
};

(node as any).hash = "6491d6c4ab2fb687d9408ff76e7f6c0a";

export default node;
